import { object, string } from "yup";

import { emailValidationSchema } from "utils/yup/emailValidationSchema";
import { validationMessages } from "utils/yup/validationMessages";
import { checkboxRequiredValidationSchema } from "utils/yup/checkboxRequiredValidationSchema";
import { useRecaptchaValidationSchema } from "utils/yup/useRecaptchaValidationSchema";

export const useRegisterFormValidationSchema = () => {
  const recaptchaValidationSchema = useRecaptchaValidationSchema();
  return object().shape({
    name: string().required(validationMessages.requiredField),
    email: emailValidationSchema.required(validationMessages.requiredField),
    phone: string(),
    password: string().required(validationMessages.requiredField),
    repeatPassword: string()
      .test(
        "repeat-password",
        "Hasła nie są takie same",
        function (repeatPassword) {
          const password = this.parent.password;
          return password === repeatPassword;
        }
      )
      .required(validationMessages.requiredField),
    termAccept: checkboxRequiredValidationSchema,
    "recaptcha-response": recaptchaValidationSchema,
  });
};
